// @ts-nocheck
import React, { useState, useEffect } from "react";
import style from "./ChangePlan.module.scss";
import PropTypes from "prop-types";
import { InfoBtn } from "../../common/Payment/InfoBtn";
import { SecondaryBtn } from "../../common/Payment/SecondaryBtn";
import { getImageUrl } from "../../../commons/assets_path";
import CurrencySelector from "./CurrencySelector";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import { useTranslation, Trans } from "react-i18next";

export const ChangePlanPriceListForOverseas = ({
  availableTrialPlans,
  pastTrialPlans,
  currentTrialPlan,
  plans,
  plan_prices,
  currentPlan,
  currentPaymentPeriod,
  selectPaymentPeriod,
  setSelectPaymentPeriod,
  setAfterPlanName,
  setAfterPlanCode,
  setTrialPlanName,
  setTrialPlanCode,
  handleShow,
  handleTrialShow,
  changePlanCheck,
  upOrDownCheck,
  client,
  currency,
  setCurrency,
}) => {
  const { t } = useTranslation();
  const [planPrices, setPlanPrices] = useState(plan_prices);

  const getPlanPrices = async (code) => {
    const endpoint = `/${client}/settings/client_plan_log/plan_prices`;
    const params = { currency: code.toLocaleLowerCase() };

    const result = await axios.get(endpoint, { params }).catch((error) => {
      return null;
    });

    if (result) {
      setPlanPrices(result.data);
    }
  };

  // プラン比較メソッド
  const getPlanChangeLabel = (targetPlanCode: string): string => {
    const PLAN_ORDER = ["global_free", "plus", "business", "enterprise"];
    const PERIOD_ORDER = ["month", "year"];
    const currentPlanIndex = PLAN_ORDER.indexOf(currentPlan.plan_code);
    const targetPlanIndex = PLAN_ORDER.indexOf(targetPlanCode);
    const currentPeriodIndex = PERIOD_ORDER.indexOf(currentPlan.period_type);
    const selectPeriodIndex = PERIOD_ORDER.indexOf(selectPaymentPeriod);

    // 対象プランが現在のプランと同じ場合は、期間で判断
    if (targetPlanCode === currentPlan.plan_code) {
      if (selectPeriodIndex > currentPeriodIndex) {
        return t("ChangePlanPriceListForOverseas.Upgrade");
      } else {
        return t("ChangePlanPriceListForOverseas.Downgrade");
      }
    }
    // 対象プランのインデックスが現在のプランより大きい場合は上位プラン
    if (targetPlanIndex > currentPlanIndex) {
      return t("ChangePlanPriceListForOverseas.Upgrade");
    } else {
      return t("ChangePlanPriceListForOverseas.Downgrade");
    }
  };

  // NOTE:通貨変更の時に使用
  // useEffect(() => {
  // getPlanPrices(currency.code);
  // }, [currency.code]);

  return (
    <>
      <div className={style.changePlanList}>
        <div className={style.changePlanWrap}>
          <div className={style.changePlanTitle} style={{ whiteSpace: "nowrap" }}>
            {t("ChangePlanPriceListForOverseas.プラン変更")}
          </div>
          <div
            className={style.paymentSwitchWrap}
            style={{ flexDirection: "row", alignItems: "center", gap: 0, justifyContent: "flex-end" }}
          >
            {/* 通貨変更実装後、通貨変更のボタンを表示 */}
            {/* <div className="mr-3">
              <CurrencySelector setCurrency={setCurrency} currency={currency} />
            </div> */}
            <div className={style.discountTag} style={{ whiteSpace: "nowrap", padding: "8px 11px" }}>
              {t("ChangePlanPriceListForOverseas.20%OFF")}
            </div>
            <div className={style.switchButton}>
              <div
                className={selectPaymentPeriod === "year" ? style.switchTypeActive : style.switchTypeDisable}
                onClick={() => setSelectPaymentPeriod("year")}
              >
                {t("ChangePlanPriceListForOverseas.年間契約切り替え")}
              </div>
              <div
                className={selectPaymentPeriod === "month" ? style.switchTypeActive : style.switchTypeDisable}
                onClick={() => setSelectPaymentPeriod("month")}
              >
                {t("ChangePlanPriceListForOverseas.月間契約切り替え")}
              </div>
            </div>
          </div>
          <div className={style.changePlanType}>
            <div className={style.changePlanItemFree}>
              <div className={style.changePlanItemFreeGradation}></div>
              <div className={style.changePlanFree}>
                <div className={style.changePlanFreeTitle}>Free</div>
                <div className={style.changePlanFreeDescription}>
                  {t("ChangePlanPriceListForOverseas.free_description")}
                </div>
              </div>
              <div className={style.changePlanFreeItemWrap}>
                <div className={style.changePlanFreeItem}>
                  <br />
                  <div className={style.changePlanFreeItemValue}>
                    <span className={style.changePlanFreeYen}>{planPrices.currency_symbol}</span>
                    <span className={style.changePlanFreeItemAmount}>0</span>
                    <span className={style.changePlanMiniYen} style={{ fontSize: "12px" }}>
                      /{t("ChangePlanPriceListForOverseas.月")}
                    </span>
                  </div>
                </div>
                <div className={style.changePlanFreeItem}>
                  <div className={style.changePlanFreeItemContent}>
                    <div>
                      <span className={`${style.changePlanFreeItemContentBold} mr-1`}>
                        {plans.global_free.free_operation_boot_count.toLocaleString()}
                      </span>
                      {t("ChangePlanPriceListForOverseas.回タスク実行無料")}
                    </div>
                    <div>
                      <Trans
                        i18nKey="ChangePlanPriceListForOverseas.{member_create_limit}人ユーザー招待無料"
                        values={{
                          member_create_limit: plans.free.default_member_create_limit,
                        }}
                        components={{
                          span: <span className={`${style.changePlanFreeItemContentBold} mr-1`} />,
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className={style.changePlanFreeItem}>
                  <ul className={style.changePlanFreeItemList}>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.Flow bots buildar")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.Custom Databases")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.Browser Automation")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.Human in the loop")}
                    </li>
                  </ul>
                </div>
                <div className={style.changePlanFreeButtonWrap}>
                  {currentPlan?.plan_code === "global_free" ? (
                    <SecondaryBtn
                      text={t("ChangePlanPriceListForOverseas.現在のプラン")}
                      disabled={true}
                      className={`test-force-upgrade ${style.changePlanFreeButton}`}
                    />
                  ) : (
                    <SecondaryBtn
                      text={t("ChangePlanPriceListForOverseas.ダウングレード")}
                      disabled={false}
                      className={`test-force-upgrade ${style.changePlanFreeButton}`}
                      submit={() => {
                        setAfterPlanName(t("ChangePlanPriceListForOverseas.フリー"));
                        setAfterPlanCode("global_free");
                        changePlanCheck("global_free");
                        handleShow();
                      }}
                      style={{ color: "#222222" }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className={style.changePlanItemMini}>
              <div className={style.changePlanItemMiniGradation}></div>
              <div className={style.changePlanMini}>
                <div className={style.changePlanMiniTitle}>Plus</div>
                <div className={style.changePlanMiniDescription}>
                  {t("ChangePlanPriceListForOverseas.plus_description")}
                </div>
              </div>
              <div className={style.changePlanMiniItemWrap}>
                <div className={style.changePlanMiniItem}>
                  <span>{selectPaymentPeriod === "year" ? "　" : t("ChangePlanPriceListForOverseas.月間契約")}</span>
                  <div className={style.changePlanMiniItemValue}>
                    <span className={style.changePlanMiniYen}>{planPrices.currency_symbol}</span>
                    <span className={style.changePlanMiniItemAmount}>
                      {plan_prices.plus.basic_price[selectPaymentPeriod].toLocaleString()}
                    </span>
                    <span className={style.changePlanMiniYen} style={{ fontSize: "12px" }}>
                      /{t("ChangePlanPriceListForOverseas.月")}
                    </span>
                  </div>
                </div>
                <div className={style.changePlanMiniItem}>
                  <div className={style.changePlanMiniItemContent}>
                    <div>
                      <span className={`${style.changePlanMiniItemContentBold} mr-1`}>
                        {plans.plus.free_operation_boot_count.toLocaleString()}
                      </span>
                      {t("ChangePlanPriceListForOverseas.回タスク実行無料")}
                    </div>
                    <div>
                      <Trans
                        i18nKey="ChangePlanPriceListForOverseas.{member_create_limit}人ユーザー招待無料"
                        values={{
                          member_create_limit: plans.plus.default_member_create_limit,
                        }}
                        components={{
                          span: <span className={`${style.changePlanFreeItemContentBold} mr-1`} />,
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className={style.changePlanMiniItem}>
                  <ul className={style.changePlanMiniItemList}>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.Unlimited Flow bots")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.15 actions per flow")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.Unlimited Apps")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.Path Settings")}
                    </li>
                  </ul>
                </div>
                <div className={style.changePlanMiniButtonWrap}>
                  {currentPlan?.plan_name === t("ChangePlanPriceListForOverseas.プラス") &&
                  currentPaymentPeriod === selectPaymentPeriod ? (
                    <SecondaryBtn
                      text={t("ChangePlanPriceListForOverseas.現在のプラン")}
                      disabled={true}
                      className={`${style.changePlanMiniButton} test-force-upgrade`}
                    />
                  ) : availableTrialPlans.includes("plus") && !pastTrialPlans.includes("plus") ? (
                    <>
                      <InfoBtn
                        text={t("ChangePlanPriceListForOverseas.無料トライアル")}
                        className={`${style.changePlanMiniButton} w-25 test-force-upgrade`}
                        submit={() => {
                          setTrialPlanName(t("ChangePlanPriceListForOverseas.プラス"));
                          setTrialPlanCode("plus");
                          handleTrialShow();
                        }}
                      />
                      <a
                        className={`${style.changePlanMiniLink} w-25 test-force-upgrade`}
                        onClick={(e) => {
                          setAfterPlanName(t("ChangePlanPriceListForOverseas.プラス"));
                          setAfterPlanCode("plus");
                          upOrDownCheck(
                            currentPlan.plan_name,
                            t("ChangePlanPriceListForOverseas.プラス"),
                            currentPaymentPeriod,
                            selectPaymentPeriod,
                          );
                          changePlanCheck("plus");
                          handleShow();
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {t("ChangePlanPriceListForOverseas.今すぐプラスに変更する")}
                      </a>
                    </>
                  ) : (
                    <>
                      <InfoBtn
                        text={getPlanChangeLabel("plus")}
                        className={`${style.changePlanMiniButton} w-25 test-force-upgrade`}
                        submit={() => {
                          setAfterPlanName(t("ChangePlanPriceListForOverseas.プラス"));
                          setAfterPlanCode("plus");
                          upOrDownCheck(
                            currentPlan.plan_name,
                            t("ChangePlanPriceListForOverseas.プラス"),
                            currentPaymentPeriod,
                            selectPaymentPeriod,
                          );
                          changePlanCheck("plus");
                          handleShow();
                        }}
                      />
                      {currentTrialPlan === "plus" ? (
                        <span className={`${style.changePlanMiniPastTrial}`}>
                          {t("ChangePlanPriceListForOverseas.現在トライアル中")}
                        </span>
                      ) : (
                        pastTrialPlans.includes("plus") && (
                          <span className={`${style.changePlanMiniPastTrial}`}>
                            {t("ChangePlanPriceListForOverseas.無料トライアル済み")}
                          </span>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className={style.changePlanItemTeam}>
              <div className={style.changePlanItemTeamGradation}></div>
              <div className={style.changePlanTeam}>
                <div className={style.changePlanTeamTitle}>Business</div>
                <div className={style.changePlanTeamDescription}>
                  {t("ChangePlanPriceListForOverseas.business_description")}
                </div>
              </div>
              <div className={style.changePlanTeamItemWrap}>
                <div className={style.changePlanTeamItem}>
                  <span>{selectPaymentPeriod === "year" ? "　" : t("ChangePlanPriceListForOverseas.月間契約")}</span>
                  <div className={style.changePlanTeamItemValue}>
                    <span className={style.changePlanTeamYen}>{plan_prices.currency_symbol}</span>
                    <span className={style.changePlanTeamItemAmount}>
                      {plan_prices.business.basic_price[selectPaymentPeriod].toLocaleString()}
                    </span>
                    <span className={style.changePlanMiniYen} style={{ fontSize: "12px" }}>
                      /{t("ChangePlanPriceListForOverseas.月")}
                    </span>
                  </div>
                </div>
                <div className={style.changePlanTeamItem}>
                  <div className={style.changePlanTeamItemContent}>
                    <div>
                      <span className={`${style.changePlanTeamItemContentBold} mr-1`}>
                        {plans.business.free_operation_boot_count.toLocaleString()}
                      </span>
                      {t("ChangePlanPriceListForOverseas.回タスク実行無料")}
                    </div>
                    <div>
                      <Trans
                        i18nKey="ChangePlanPriceListForOverseas.{member_create_limit}人ユーザー招待無料"
                        values={{
                          member_create_limit: "Unlimited",
                        }}
                        components={{
                          span: <span className={`${style.changePlanFreeItemContentBold} mr-1`} />,
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className={style.changePlanTeamItem}>
                  <ul className={style.changePlanTeamItemList}>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.100 actions per flow")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.Unlimited Users")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.Project Permissions")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.IP address restriction")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.OCR")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.Transcription")}
                    </li>
                  </ul>
                </div>
                <div className={style.changePlanTeamButtonWrap}>
                  {currentPlan?.plan_name === t("ChangePlanPriceListForOverseas.ビジネス") &&
                  currentPaymentPeriod === selectPaymentPeriod ? (
                    <SecondaryBtn
                      text={t("ChangePlanPriceListForOverseas.現在のプラン")}
                      disabled={true}
                      className={`${style.changePlanTeamButton} test-force-upgrade`}
                    />
                  ) : availableTrialPlans.includes("business") && !pastTrialPlans.includes("business") ? (
                    <>
                      <InfoBtn
                        text={t("ChangePlanPriceListForOverseas.無料トライアル")}
                        className={`${style.changePlanTeamButton} w-25 test-force-upgrade`}
                        submit={() => {
                          setTrialPlanName(t("ChangePlanPriceListForOverseas.ビジネス"));
                          setTrialPlanCode("business");
                          handleTrialShow();
                        }}
                      />
                      <a
                        className={`${style.changePlanTeamLink} w-25 test-force-upgrade`}
                        onClick={(e) => {
                          setAfterPlanName(t("ChangePlanPriceListForOverseas.ビジネス"));
                          setAfterPlanCode("business");
                          upOrDownCheck(
                            currentPlan.plan_name,
                            t("ChangePlanPriceListForOverseas.ビジネス"),
                            currentPaymentPeriod,
                            selectPaymentPeriod,
                          );
                          changePlanCheck("business");
                          handleShow();
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {t("ChangePlanPriceListForOverseas.今すぐビジネスに変更する")}
                      </a>
                    </>
                  ) : (
                    <>
                      <InfoBtn
                        text={getPlanChangeLabel("business")}
                        className={`${style.changePlanTeamButton} w-25 test-force-upgrade`}
                        submit={() => {
                          setAfterPlanName(t("ChangePlanPriceListForOverseas.ビジネス"));
                          setAfterPlanCode("business");
                          upOrDownCheck(
                            currentPlan.plan_name,
                            t("ChangePlanPriceListForOverseas.ビジネス"),
                            currentPaymentPeriod,
                            selectPaymentPeriod,
                          );
                          changePlanCheck("business");
                          handleShow();
                        }}
                      />
                      {currentTrialPlan === "business" ? (
                        <span className={`${style.changePlanMiniPastTrial}`}>
                          {t("ChangePlanPriceListForOverseas.現在トライアル中")}
                        </span>
                      ) : (
                        pastTrialPlans.includes("business") && (
                          <span className={`${style.changePlanMiniPastTrial}`}>
                            {t("ChangePlanPriceListForOverseas.無料トライアル済み")}
                          </span>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className={style.changePlanItemSuccess}>
              <div className={style.changePlanItemSuccessGradation}></div>
              <div className={style.changePlanSuccess}>
                <div className={style.changePlanSuccessTitle}>Enterprise</div>
                <div className={style.changePlanSuccessDescription}>
                  {t("ChangePlanPriceListForOverseas.enterprise_description")}
                </div>
              </div>
              <div className={style.changePlanSuccessItemWrap}>
                <div className={style.changePlanSuccessItem}>
                  <span>{selectPaymentPeriod === "year" ? "　" : t("ChangePlanPriceListForOverseas.月間契約")}</span>
                  <div className={style.changePlanSuccessItemValue}>
                    <span className={style.changePlanSuccessYen}>{plan_prices.currency_symbol}</span>
                    <span className={style.changePlanSuccessItemAmount}>
                      {plan_prices.enterprise.basic_price[selectPaymentPeriod].toLocaleString()}
                    </span>
                    <span className={style.changePlanMiniYen} style={{ fontSize: "12px" }}>
                      /{t("ChangePlanPriceListForOverseas.月")}
                    </span>
                  </div>
                </div>
                <div className={style.changePlanSuccessItem}>
                  <div className={style.changePlanSuccessItemContent}>
                    <div>
                      <span className={`${style.changePlanSuccessItemContentBold} mr-1`}>
                        {plans.enterprise.free_operation_boot_count.toLocaleString()}
                      </span>
                      {t("ChangePlanPriceListForOverseas.回タスク実行無料")}
                    </div>
                    <div>
                      <Trans
                        i18nKey="ChangePlanPriceListForOverseas.{member_create_limit}人ユーザー招待無料"
                        values={{
                          member_create_limit: "Unlimited",
                        }}
                        components={{
                          span: <span className={`${style.changePlanFreeItemContentBold} mr-1`} />,
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className={style.changePlanSuccessItem}>
                  <ul className={style.changePlanSuccessItemList}>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.300 actions per flow")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.Expert Support")}
                    </li>
                    <li className="mt-auto">
                      <img
                        src={getImageUrl("images/icons/check.svg")}
                        style={{ width: "16px", height: "16px", marginRight: "4px" }}
                      />
                      {t("ChangePlanPriceListForOverseas.Advanced Security")}
                    </li>
                  </ul>
                </div>
                <div className={style.changePlanSuccessButtonWrap}>
                  {currentPlan?.plan_name === t("ChangePlanPriceListForOverseas.エンタープライズ") &&
                  currentPaymentPeriod === selectPaymentPeriod ? (
                    <SecondaryBtn
                      text={t("ChangePlanPriceListForOverseas.現在のプラン")}
                      disabled={true}
                      className={`${style.changePlanSuccessButton} test-force-upgrade`}
                    />
                  ) : availableTrialPlans.includes("enterprise") && !pastTrialPlans.includes("enterprise") ? (
                    <>
                      <InfoBtn
                        text={t("ChangePlanPriceListForOverseas.無料トライアル")}
                        className={`${style.changePlanSuccessButton} w-25 test-force-upgrade`}
                        submit={() => {
                          setTrialPlanName(t("ChangePlanPriceListForOverseas.エンタープライズ"));
                          setTrialPlanCode("enterprise");
                          handleTrialShow();
                        }}
                      />
                      <a
                        className={`${style.changePlanSuccessLink} w-25 test-force-upgrade`}
                        onClick={(e) => {
                          setAfterPlanName(t("ChangePlanPriceListForOverseas.エンタープライズ"));
                          setAfterPlanCode("enterprise");
                          upOrDownCheck(
                            currentPlan.plan_name,
                            t("ChangePlanPriceListForOverseas.エンタープライズ"),
                            currentPaymentPeriod,
                            selectPaymentPeriod,
                          );
                          changePlanCheck("enterprise");
                          handleShow();
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {t("ChangePlanPriceListForOverseas.今すぐエンタープライズに変更する")}
                      </a>
                    </>
                  ) : (
                    <>
                      <InfoBtn
                        text={getPlanChangeLabel("enterprise")}
                        className={`${style.changePlanSuccessButton} w-25 test-force-upgrade`}
                        submit={() => {
                          setAfterPlanName(t("ChangePlanPriceListForOverseas.エンタープライズ"));
                          setAfterPlanCode("enterprise");
                          upOrDownCheck(
                            currentPlan.plan_name,
                            t("ChangePlanPriceListForOverseas.エンタープライズ"),
                            currentPaymentPeriod,
                            selectPaymentPeriod,
                          );
                          changePlanCheck("enterprise");
                          handleShow();
                        }}
                      />
                      {currentTrialPlan === "enterprise" ? (
                        <span className={`${style.changePlanMiniPastTrial}`}>
                          {t("ChangePlanPriceListForOverseas.現在トライアル中")}
                        </span>
                      ) : (
                        pastTrialPlans.includes("enterprise") && (
                          <span className={`${style.changePlanMiniPastTrial}`}>
                            {t("ChangePlanPriceListForOverseas.無料トライアル済み")}
                          </span>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={style.changePlanPriceListTitle}>{t("ChangePlanPriceListForOverseas.プラン比較")}</div>
          <div className={style.changePlanPriceList}>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitleStart}>{t("ChangePlanPriceListForOverseas.プラン")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueStartFree}>Free</div>
                <div className={style.changePlanPriceValueStartMini}>Plus</div>
                <div className={style.changePlanPriceValueStartTeam}>Business</div>
                <div className={style.changePlanPriceValueStartSuccess}>Enterprise</div>
              </div>
            </div>
            <div className={style.changePlanTaskRowItems} style={{ height: "48px" }}>
              <div className={style.changePlanTaskTitle} style={{ height: "100%" }}>
                {t("ChangePlanPriceListForOverseas.Monthly fee")}
              </div>
              <div className={style.changePlanTaskValueWrap} style={{ height: "100%" }}>
                <div className={style.changePlanTaskValueFree}></div>
                <div className={style.changePlanTaskValueMini} style={{ gap: "2px" }}>
                  <span>
                    {t("ChangePlanPriceListForOverseas.Monthly_fee_value", {
                      basic_price: plan_prices.plus.basic_price["month"].toLocaleString(),
                      paymentPeriod: "monthly",
                    })}
                  </span>
                  <span>
                    {t("ChangePlanPriceListForOverseas.Monthly_fee_value", {
                      basic_price: plan_prices.plus.basic_price["year"].toLocaleString(),
                      paymentPeriod: "annual",
                    })}
                  </span>
                </div>
                <div className={style.changePlanTaskValueTeam} style={{ gap: "2px" }}>
                  <span>
                    {t("ChangePlanPriceListForOverseas.Monthly_fee_value", {
                      basic_price: plan_prices.business.basic_price["month"].toLocaleString(),
                      paymentPeriod: "monthly",
                    })}
                  </span>
                  <span>
                    {t("ChangePlanPriceListForOverseas.Monthly_fee_value", {
                      basic_price: plan_prices.business.basic_price["year"].toLocaleString(),
                      paymentPeriod: "annual",
                    })}
                  </span>
                </div>
                <div className={style.changePlanTaskValueSuccess} style={{ gap: "2px" }}>
                  <span>
                    {t("ChangePlanPriceListForOverseas.Monthly_fee_value", {
                      basic_price: plan_prices.enterprise.basic_price["month"].toLocaleString(),
                      paymentPeriod: "monthly",
                    })}
                  </span>
                  <span>
                    {t("ChangePlanPriceListForOverseas.Monthly_fee_value", {
                      basic_price: plan_prices.enterprise.basic_price["year"].toLocaleString(),
                      paymentPeriod: "annual",
                    })}
                  </span>
                </div>
              </div>
            </div>
            {/* <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.契約期間")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}>
                  {selectPaymentPeriod === "month"
                    ? t("ChangePlanPriceListForOverseas.月間契約")
                    : t("ChangePlanPriceListForOverseas.年間契約")}
                </div>
                <div className={style.changePlanPriceValueTeam}>
                  {selectPaymentPeriod === "month"
                    ? t("ChangePlanPriceListForOverseas.月間契約")
                    : t("ChangePlanPriceListForOverseas.年間契約")}
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  {selectPaymentPeriod === "month"
                    ? t("ChangePlanPriceListForOverseas.月間契約")
                    : t("ChangePlanPriceListForOverseas.年間契約")}
                </div>
              </div>
            </div> */}
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.月の無料タスク数")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>
                  {t("ChangePlanPriceListForOverseas.free_task_count_for_month", {
                    free_task_count: plans.global_free.free_operation_boot_count.toLocaleString(),
                  })}
                </div>
                <div className={style.changePlanPriceValueMini}>
                  {t("ChangePlanPriceListForOverseas.free_task_count_for_month", {
                    free_task_count: plans.plus.free_operation_boot_count.toLocaleString(),
                  })}
                </div>
                <div className={style.changePlanPriceValueTeam}>
                  {t("ChangePlanPriceListForOverseas.free_task_count_for_month", {
                    free_task_count: plans.business.free_operation_boot_count.toLocaleString(),
                  })}
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  {t("ChangePlanPriceListForOverseas.free_task_count_for_month", {
                    free_task_count: plans.enterprise.free_operation_boot_count.toLocaleString(),
                  })}
                </div>
              </div>
            </div>
            <div className={style.changePlanTaskRowItems}>
              <div className={style.changePlanTaskTitle}>{t("ChangePlanPriceListForOverseas.追加タスク料金")}</div>
              <div className={style.changePlanTaskValueWrap} style={{ height: "100%" }}>
                <div className={style.changePlanTaskValueFree} style={{ minWidth: "187px" }}></div>
                <div
                  className={style.changePlanTaskValueMini}
                  style={{ gap: "3px", paddingRight: 0, minWidth: "186px" }}
                >
                  <span>
                    {t("ChangePlanPriceListForOverseas.additional_task_fee", {
                      additional_task_fee:
                        plan_prices.plus.operation_boot_price.unit_amount_decimal_range["month"].toLocaleString(),
                      paymentPeriod: "monthly",
                    })}
                  </span>
                  <span>
                    {t("ChangePlanPriceListForOverseas.additional_task_fee", {
                      additional_task_fee:
                        plan_prices.plus.operation_boot_price.unit_amount_decimal_range["year"].toLocaleString(),
                      paymentPeriod: "annual",
                    })}
                  </span>
                </div>
                <div
                  className={style.changePlanTaskValueTeam}
                  style={{ gap: "3px", paddingRight: 0, minWidth: "187px" }}
                >
                  <span>
                    {t("ChangePlanPriceListForOverseas.additional_task_fee", {
                      additional_task_fee:
                        plan_prices.business.operation_boot_price.unit_amount_decimal_range["month"].toLocaleString(),
                      paymentPeriod: "monthly",
                    })}
                  </span>
                  <span>
                    {t("ChangePlanPriceListForOverseas.additional_task_fee", {
                      additional_task_fee:
                        plan_prices.business.operation_boot_price.unit_amount_decimal_range["year"].toLocaleString(),
                      paymentPeriod: "annual",
                    })}
                  </span>
                </div>
                <div
                  className={style.changePlanTaskValueSuccess}
                  style={{ gap: "3px", paddingRight: 0, minWidth: "187px" }}
                >
                  <span>
                    {t("ChangePlanPriceListForOverseas.additional_task_fee", {
                      additional_task_fee:
                        plan_prices.enterprise.operation_boot_price.unit_amount_decimal_range["month"].toLocaleString(),
                      paymentPeriod: "monthly",
                    })}
                  </span>
                  <span>
                    {t("ChangePlanPriceListForOverseas.additional_task_fee", {
                      additional_task_fee:
                        plan_prices.enterprise.operation_boot_price.unit_amount_decimal_range["year"].toLocaleString(),
                      paymentPeriod: "annual",
                    })}
                  </span>
                </div>
              </div>
            </div>
            {/* <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.プロジェクト作成数")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{plans.global_free.custom_sections_limit}</div>
                <div className={style.changePlanPriceValueMini}>{plans.plus.custom_sections_limit}</div>
                <div className={style.changePlanPriceValueTeam}>{plans.business.custom_sections_limit}</div>
                <div className={style.changePlanPriceValueSuccess}>{plans.enterprise.custom_sections_limit}</div>
              </div>
            </div> */}
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.Users")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>
                  {t("ChangePlanPriceListForOverseas.user_count", {
                    user_count: plans.global_free.default_member_create_limit,
                  })}
                </div>
                <div className={style.changePlanPriceValueMini}>
                  {t("ChangePlanPriceListForOverseas.user_count", {
                    user_count: plans.plus.default_member_create_limit,
                  })}
                </div>
                <div className={style.changePlanPriceValueTeam}>
                  {t("ChangePlanPriceListForOverseas.user_count", {
                    user_count: "Unlimited",
                  })}
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  {t("ChangePlanPriceListForOverseas.user_count", {
                    user_count: "Unlimited",
                  })}
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.プロジェクト権限")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.フローボット作成数")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{plans.global_free.workflow_template_create_limit}</div>
                <div className={style.changePlanPriceValueMini}>{t("ChangePlanPriceListForOverseas.無制限")}</div>
                <div className={style.changePlanPriceValueTeam}>{t("ChangePlanPriceListForOverseas.無制限")}</div>
                <div className={style.changePlanPriceValueSuccess}>{t("ChangePlanPriceListForOverseas.無制限")}</div>
              </div>
            </div>
            {/* <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>
                <Trans
                  i18nKey="ChangePlanPriceListForOverseas.1フローボットの<br />オペレーション数"
                  components={{ br: <br /> }}
                />
              </div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>
                  {plans.global_free.max_operation_count_per_workflow}
                </div>
                <div className={style.changePlanPriceValueMini}>{plans.plus.max_operation_count_per_workflow}</div>
                <div className={style.changePlanPriceValueTeam}>{plans.business.max_operation_count_per_workflow}</div>
                <div className={style.changePlanPriceValueSuccess}>
                  {plans.enterprise.max_operation_count_per_workflow}
                </div>
              </div>
            </div> */}
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.連携可能なアプリ")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div
                  className={style.changePlanPriceValueFree}
                  style={{
                    whiteSpace: "nowrap",
                    padding: "16px 0",
                    fontSize: "12px",
                    flexDirection: "row",
                    minWidth: "187px",
                    gap: "4px",
                  }}
                >
                  <Trans
                    i18nKey="ChangePlanPriceListForOverseas.exclude_some_apps"
                    components={{
                      a: (
                        <a
                          className="m-0"
                          href="https://intercom.help/yoom/en/articles/8885225"
                          target="_blank"
                          rel="noopener noreferrer"
                        />
                      ),
                    }}
                  />
                </div>
                <div className={style.changePlanPriceValueMini} style={{ paddingRight: "30px" }}>
                  {t("ChangePlanPriceListForOverseas.すべてのアプリ")}
                </div>
                <div className={style.changePlanPriceValueTeam}>
                  {t("ChangePlanPriceListForOverseas.すべてのアプリ")}
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  {t("ChangePlanPriceListForOverseas.すべてのアプリ")}
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems} style={{ height: "60px" }}>
              <div className={style.changePlanPriceTitle} style={{ gap: 0, height: "100%" }}>
                <Trans
                  i18nKey="ChangePlanPriceListForOverseas.独自APIとの連携(カスタムアプリ・アクション)"
                  components={{ br: <br /> }}
                />
                <div style={{ fontSize: "10px", fontWeight: "bold", lineHeight: "11px" }}>
                  ・Custom apps <br />
                  ・Custom actions
                </div>
              </div>
              <div className={style.changePlanPriceValueWrap} style={{ height: "100%" }}>
                <div className={style.changePlanPriceValueFree} style={{ height: "100%" }}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueMini} style={{ height: "100%" }}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueTeam} style={{ height: "100%" }}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess} style={{ height: "100%" }}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.OCR")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.Transcription")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>
                {t("ChangePlanPriceListForOverseas.ブラウザ操作の自動化")}
              </div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueMini}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueTeam}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.path_settings")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueTeam}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            {/* <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>
                {t("ChangePlanPriceListForOverseas.オペレーション間の操作")}
              </div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>-</div>
                <div className={style.changePlanPriceValueMini}>
                  <span style={{ fontSize: "12px" }}>
                    <Trans
                      i18nKey="ChangePlanPriceListForOverseas.分岐・進行先切り替え・移動"
                      components={{ br: <br /> }}
                    />
                  </span>
                </div>
                <div className={style.changePlanPriceValueTeam}>{t("ChangePlanPriceListForOverseas.全ての操作")}</div>
                <div className={style.changePlanPriceValueSuccess}>
                  {t("ChangePlanPriceListForOverseas.全ての操作")}
                </div>
              </div>
            </div> */}
            <div className={style.changePlanPriceRowItems} style={{ height: "60px" }}>
              <div className={style.changePlanPriceTitle} style={{ height: "100%" }}>
                {t("ChangePlanPriceListForOverseas.フォームのカスタマイズ")}
              </div>
              <div className={style.changePlanPriceValueWrap} style={{ height: "100%" }}>
                <div className={style.changePlanPriceValueFree} style={{ height: "100% " }}>
                  -
                </div>
                <div
                  className={style.changePlanPriceValueMini}
                  style={{
                    paddingLeft: "32px",
                    paddingRight: "0",
                    height: "100%",
                    fontSize: "12px",
                    minWidth: "186px",
                  }}
                >
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                  {t("ChangePlanPriceListForOverseas.（IP制限以外）")}
                </div>
                <div className={style.changePlanPriceValueTeam} style={{ height: "100%" }}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess} style={{ height: "100%" }}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            {/* <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.Webhook受信上限")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{`${
                  plans.global_free.webhook_trigger_receive_limit
                } / ${t("ChangePlanPriceListForOverseas.1分間")}`}</div>
                <div className={style.changePlanPriceValueMini}>{`${plans.plus.webhook_trigger_receive_limit} / ${t(
                  "ChangePlanPriceListForOverseas.1分間",
                )}`}</div>
                <div className={style.changePlanPriceValueTeam}>{`${plans.business.webhook_trigger_receive_limit} / ${t(
                  "ChangePlanPriceListForOverseas.1分間",
                )}`}</div>
                <div className={style.changePlanPriceValueSuccess}>{`${
                  plans.enterprise.webhook_trigger_receive_limit
                }/ ${t("ChangePlanPriceListForOverseas.1分間")}`}</div>
              </div>
            </div> */}
            {/* <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.トリガー起動間隔")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{t("ChangePlanPriceListForOverseas.15分に1度")}</div>
                <div className={style.changePlanPriceValueMini}>{t("ChangePlanPriceListForOverseas.10分に1度")}</div>
                <div className={style.changePlanPriceValueTeam}>{t("ChangePlanPriceListForOverseas.5分に1度")}</div>
                <div className={style.changePlanPriceValueSuccess}>{t("ChangePlanPriceListForOverseas.5分に1度")}</div>
              </div>
            </div> */}
            {/* <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.取得した値の保存数")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>
                  {plans.global_free.max_output_count_per_workflow.toLocaleString()}
                </div>
                <div className={style.changePlanPriceValueMini}>
                  {plans.plus.max_output_count_per_workflow.toLocaleString()}
                </div>
                <div className={style.changePlanPriceValueTeam}>
                  {plans.business.max_output_count_per_workflow.toLocaleString()}
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  {plans.enterprise.max_output_count_per_workflow.toLocaleString()}
                </div>
              </div>
            </div> */}
            {/* <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.データベース作成数")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>
                  {plans.global_free.dynamic_database_limit.toLocaleString()}
                </div>
                <div className={style.changePlanPriceValueMini}>
                  {plans.plus.dynamic_database_limit.toLocaleString()}
                </div>
                <div className={style.changePlanPriceValueTeam}>
                  {plans.business.dynamic_database_limit.toLocaleString()}
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  {plans.enterprise.dynamic_database_limit.toLocaleString()}
                </div>
              </div>
            </div> */}
            {/* <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>
                <Trans
                  i18nKey="ChangePlanPriceListForOverseas.1テーブルあたりデーターベーストリガー数"
                  components={{ br: <br /> }}
                />
              </div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{plans.global_free.db_trigger_table_active_limit}</div>
                <div className={style.changePlanPriceValueMini}>{plans.plus.db_trigger_table_active_limit}</div>
                <div className={style.changePlanPriceValueTeam}>{plans.business.db_trigger_table_active_limit}</div>
                <div className={style.changePlanPriceValueSuccess}>
                  {plans.enterprise.db_trigger_table_active_limit}
                </div>
              </div>
            </div> */}
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.database_rows")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree} style={{ fontSize: "12px" }}>
                  {`100 ${t("ChangePlanPriceListForOverseas.列")} × `}
                  <br />
                  {`${plans.global_free.dynamic_table_record_limit.toLocaleString()} ${t(
                    "ChangePlanPriceListForOverseas.行",
                  )}`}
                </div>
                <div className={style.changePlanPriceValueMini} style={{ fontSize: "12px" }}>{`100 ${t(
                  "ChangePlanPriceListForOverseas.列",
                )} × ${plans.plus.dynamic_table_record_limit.toLocaleString()} ${t(
                  "ChangePlanPriceListForOverseas.行",
                )}`}</div>
                <div className={style.changePlanPriceValueTeam} style={{ fontSize: "12px" }}>{`100 ${t(
                  "ChangePlanPriceListForOverseas.列",
                )} × ${plans.business.dynamic_table_record_limit.toLocaleString()} ${t(
                  "ChangePlanPriceListForOverseas.行",
                )}`}</div>
                <div className={style.changePlanPriceValueSuccess} style={{ fontSize: "12px" }}>{`100 ${t(
                  "ChangePlanPriceListForOverseas.列",
                )} × ${plans.enterprise.dynamic_table_record_limit.toLocaleString()} ${t(
                  "ChangePlanPriceListForOverseas.行",
                )}`}</div>
              </div>
            </div>
            {/* <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>
                {t("ChangePlanPriceListForOverseas.データコネクトの同期頻度")}
              </div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{t("ChangePlanPriceListForOverseas.1日に1回")}</div>
                <div className={style.changePlanPriceValueMini}>{t("ChangePlanPriceListForOverseas.6時間に1回")}</div>
                <div className={style.changePlanPriceValueTeam}>{t("ChangePlanPriceListForOverseas.1時間に1回")}</div>
                <div className={style.changePlanPriceValueSuccess}>
                  {t("ChangePlanPriceListForOverseas.1時間に1回")}
                </div>
              </div>
            </div> */}
            {/* <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.ゲスト招待")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{`${plans.global_free.guest_create_limit}${t(
                  "ChangePlanPriceListForOverseas.名",
                )}`}</div>
                <div className={style.changePlanPriceValueMini}>{`${plans.plus.guest_create_limit}${t(
                  "ChangePlanPriceListForOverseas.名",
                )}`}</div>
                <div className={style.changePlanPriceValueTeam}>{`${plans.business.guest_create_limit}${t(
                  "ChangePlanPriceListForOverseas.名",
                )}`}</div>
                <div className={style.changePlanPriceValueSuccess}>{`${plans.enterprise.guest_create_limit}${t(
                  "ChangePlanPriceListForOverseas.名",
                )}`}</div>
              </div>
            </div> */}
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.IP制限")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.SAML認証によるSSO")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}></div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.2要素認証の必須化")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}></div>
                <div className={style.changePlanPriceValueMini}></div>
                <div className={style.changePlanPriceValueTeam}></div>
                <div className={style.changePlanPriceValueSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitle}>{t("ChangePlanPriceListForOverseas.サポート")}</div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueFree}>{t("ChangePlanPriceListForOverseas.チャット")}</div>
                <div className={style.changePlanPriceValueMini}>{t("ChangePlanPriceListForOverseas.チャット")}</div>
                <div
                  className={style.changePlanPriceValueTeam}
                  style={{ paddingRight: "0", minWidth: "187px", fontSize: "12px" }}
                >
                  <Trans
                    i18nKey="ChangePlanPriceListForOverseas.メール・チャット（優先対応）"
                    components={{ br: <br /> }}
                  />
                </div>
                <div
                  className={style.changePlanPriceValueSuccess}
                  style={{ paddingRight: "0", minWidth: "187px", fontSize: "12px" }}
                >
                  <Trans
                    i18nKey="ChangePlanPriceListForOverseas.メール・チャット（優先対応）"
                    components={{ br: <br /> }}
                  />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems}>
              <div className={style.changePlanPriceTitleEnd}>
                {t("ChangePlanPriceListForOverseas.専門スタッフの構築支援")}
              </div>
              <div className={style.changePlanPriceValueWrap}>
                <div className={style.changePlanPriceValueEndFree}></div>
                <div className={style.changePlanPriceValueEndMini}></div>
                <div className={style.changePlanPriceValueEndTeam}></div>
                <div className={style.changePlanPriceValueEndSuccess}>
                  <img src={getImageUrl("images/icons/check.svg")} style={{ width: "20px", height: "20px" }} />
                </div>
              </div>
            </div>
            <div className={style.changePlanPriceRowItems} style={{ marginTop: "24px" }}>
              <div className={style.changePlanPriceValueWrap}>
                <div style={{ marginLeft: "12px", marginRight: "12px" }}>
                  {currentPlan?.plan_name === t("ChangePlanPriceListForOverseas.フリー") ? (
                    <SecondaryBtn
                      text={t("ChangePlanPriceListForOverseas.現在のプラン")}
                      disabled={true}
                      className={`test-force-upgrade ${style.changePlanFreeButton}`}
                    />
                  ) : (
                    <SecondaryBtn
                      text={t("ChangePlanPriceListForOverseas.ダウングレード")}
                      disabled={false}
                      className={`test-force-upgrade ${style.changePlanFreeButton}`}
                      submit={() => {
                        setAfterPlanName(t("ChangePlanPriceListForOverseas.フリー"));
                        setAfterPlanCode("global_free");
                        changePlanCheck("global_free");
                        handleShow();
                      }}
                    />
                  )}
                </div>
                <div style={{ marginLeft: "12px", marginRight: "12px" }}>
                  {currentPlan?.plan_name === t("ChangePlanPriceListForOverseas.プラス") &&
                  currentPaymentPeriod === selectPaymentPeriod ? (
                    <SecondaryBtn
                      text={t("ChangePlanPriceListForOverseas.現在のプラン")}
                      disabled={true}
                      className={`${style.changePlanMiniButton} test-force-upgrade`}
                    />
                  ) : availableTrialPlans.includes("plus") && !pastTrialPlans.includes("plus") ? (
                    <InfoBtn
                      text={t("ChangePlanPriceListForOverseas.無料トライアル")}
                      className={`${style.changePlanMiniButton} test-force-upgrade`}
                      submit={() => {
                        setTrialPlanName(t("ChangePlanPriceListForOverseas.プラス"));
                        setTrialPlanCode("plus");
                        handleTrialShow();
                      }}
                    />
                  ) : (
                    <>
                      <InfoBtn
                        text={getPlanChangeLabel("plus")}
                        className={`${style.changePlanMiniButton} test-force-upgrade`}
                        submit={() => {
                          setAfterPlanName(t("ChangePlanPriceListForOverseas.プラス"));
                          setAfterPlanCode("plus");
                          upOrDownCheck(
                            currentPlan.plan_name,
                            t("ChangePlanPriceListForOverseas.プラス"),
                            currentPaymentPeriod,
                            selectPaymentPeriod,
                          );
                          changePlanCheck("plus");
                          handleShow();
                        }}
                      />
                    </>
                  )}
                </div>
                <div style={{ marginLeft: "12px", marginRight: "12px" }}>
                  {currentPlan?.plan_name === t("ChangePlanPriceListForOverseas.ビジネス") &&
                  currentPaymentPeriod === selectPaymentPeriod ? (
                    <SecondaryBtn
                      text={t("ChangePlanPriceListForOverseas.現在のプラン")}
                      disabled={true}
                      className={`${style.changePlanTeamButton} test-force-upgrade`}
                    />
                  ) : availableTrialPlans.includes("business") && !pastTrialPlans.includes("business") ? (
                    <InfoBtn
                      text={t("ChangePlanPriceListForOverseas.無料トライアル")}
                      className={`${style.changePlanTeamButton} test-force-upgrade`}
                      submit={() => {
                        setTrialPlanName(t("ChangePlanPriceListForOverseas.ビジネス"));
                        setTrialPlanCode("business");
                        handleTrialShow();
                      }}
                    />
                  ) : (
                    <InfoBtn
                      text={getPlanChangeLabel("business")}
                      className={`${style.changePlanTeamButton} test-force-upgrade w-25`}
                      submit={() => {
                        setAfterPlanName(t("ChangePlanPriceListForOverseas.ビジネス"));
                        setAfterPlanCode("business");
                        upOrDownCheck(
                          currentPlan.plan_name,
                          t("ChangePlanPriceListForOverseas.ビジネス"),
                          currentPaymentPeriod,
                          selectPaymentPeriod,
                        );
                        changePlanCheck("business");
                        handleShow();
                      }}
                      style={{ whiteSpace: "nowrap" }}
                    />
                  )}
                </div>
                <div style={{ marginLeft: "12px", marginRight: "12px" }}>
                  {currentPlan?.plan_name === t("ChangePlanPriceListForOverseas.エンタープライズ") &&
                  currentPaymentPeriod === selectPaymentPeriod ? (
                    <SecondaryBtn
                      text={t("ChangePlanPriceListForOverseas.現在のプラン")}
                      disabled={true}
                      className={`${style.changePlanSuccessButton} test-force-upgrade`}
                    />
                  ) : availableTrialPlans.includes("enterprise") && !pastTrialPlans.includes("enterprise") ? (
                    <InfoBtn
                      text={t("ChangePlanPriceListForOverseas.無料トライアル")}
                      className={`${style.changePlanSuccessButton} test-force-upgrade`}
                      submit={() => {
                        setTrialPlanName(t("ChangePlanPriceListForOverseas.エンタープライズ"));
                        setTrialPlanCode("enterprise");
                        handleTrialShow();
                      }}
                    />
                  ) : (
                    <InfoBtn
                      text={getPlanChangeLabel("enterprise")}
                      className={`${style.changePlanSuccessButton} test-force-upgrade`}
                      submit={() => {
                        setAfterPlanName(t("ChangePlanPriceListForOverseas.エンタープライズ"));
                        setAfterPlanCode("enterprise");
                        upOrDownCheck(
                          currentPlan.plan_name,
                          t("ChangePlanPriceListForOverseas.エンタープライズ"),
                          currentPaymentPeriod,
                          selectPaymentPeriod,
                        );
                        changePlanCheck("enterprise");
                        handleShow();
                      }}
                      style={{ whiteSpace: "nowrap" }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div style={{ marginTop: "20px", marginBottom: "20px", marginLeft: "10px" }}>
              <div>
                {t("ChangePlanPriceListForOverseas.※ 料金・プラン・お支払いに関する詳細は")}
                <Trans
                  i18nKey="ChangePlanPriceListForOverseas.plan_detail_anchor_link"
                  components={{
                    a: (
                      <a
                        className="m-0"
                        href="https://intercom.help/yoom/en/collections/3480938"
                        target="_blank"
                        rel="noopener noreferrer"
                      />
                    ),
                  }}
                />
              </div>
              <div>{t("ChangePlanPriceListForOverseas.※ 価格はすべて税別です。")}</div>
              <div>{t("ChangePlanPriceListForOverseas.※ お支払いは月末締翌月初請求書発行です。")}</div>
              <div>
                {t(
                  "ChangePlanPriceListForOverseas.※ プランはすべて自動更新です。プラン変更を希望の場合は、更新日までに変更をお願いいたします。",
                )}
              </div>
              <div>
                {t("ChangePlanPriceListForOverseas.※ タスクのカウント方法については")}
                <Trans
                  i18nKey="ChangePlanPriceListForOverseas.task_count_info_link"
                  components={{
                    a: (
                      <a
                        className="m-0"
                        href="https://intercom.help/yoom/en/articles/7949340"
                        target="_blank"
                        rel="noopener noreferrer"
                      />
                    ),
                  }}
                />
              </div>
              <div>
                {t(
                  "ChangePlanPriceListForOverseas.※ エンタープライズプランに月間契約はありません。プラスプラン・ビジネスプランに月間契約はありません。",
                )}
              </div>
              <div>
                {t(
                  "ChangePlanPriceListForOverseas.※ 申込初月の基本料金は、申込日が11~20日の場合は基本料金の2/3の料金、申込日が21日〜末日の場合は基本料金の1/3の料金をご請求いたします。月の途中で有料プランから有料プランにアップグレードした場合は、変更日に関わらず、プラン変更後の基本料金を適用します。割引は行いませんので、ご注意ください。",
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ChangePlanPriceListForOverseas.propTypes = {
  availableTrialPlans: PropTypes.array,
  pastTrialPlans: PropTypes.array,
  currentTrialPlan: PropTypes.string,
  plans: PropTypes.object,
  plan_prices: PropTypes.object,
  currentPlan: PropTypes.object,
  currentPaymentPeriod: PropTypes.string,
  selectPaymentPeriod: PropTypes.string,
  setSelectPaymentPeriod: PropTypes.func,
  setAfterPlanName: PropTypes.func,
  setAfterPlanCode: PropTypes.func,
  setTrialPlanName: PropTypes.func,
  setTrialPlanCode: PropTypes.func,
  handleShow: PropTypes.func,
  handleTrialShow: PropTypes.func,
  changePlanCheck: PropTypes.func,
  upOrDownCheck: PropTypes.func,
  client: PropTypes.string,
  currency: PropTypes.object,
  setCurrency: PropTypes.func,
};
